import { Label } from '@/components/atoms/texts/label';
import React from 'react';
import { useTranslation } from 'react-i18next';

const STEP_COLOR_BY_STEP = {
    PERSONAL_INFO: { bg: '#F2EEE8', text: '#5C4F47' },
    DOCUMENTS: { bg: '#FCEBEB', text: '#99261C' },
    CURRENT_MISSION: { bg: '#FCE5CD', text: '#974706' },
    SYNAPSE_VALIDATION: { bg: '#F4CCFF', text: '#5B2C6F' },
    ADMINISTRATIVE_INFO: { bg: '#E5D9F2', text: '#3C3489' },
    CONTRACT_GENERATION: { bg: '#EEEDFE', text: '#3C3489' },
    OFFICE_APPOINTMENT: { bg: '#E2F0FF', text: '#1E40AF' },
    COMPLETE: { bg: '#EAF3DE', text: '#27500A' },
};

const OnboardingStepTag = ({ step, className = '' }) => {
    const [t] = useTranslation('global');
    const stepColor = STEP_COLOR_BY_STEP[step] || STEP_COLOR_BY_STEP.PERSONAL_INFO;
    const STEP_BADGE_CLASS_BY_STEP = {
        PERSONAL_INFO: 'bg-[#EAF3DE] text-[#27500A]',
        DOCUMENTS: 'bg-[#FCEBEB] text-[#791F1F]',
        CURRENT_MISSION: 'bg-[#FCEBEB] text-[#791F1F]',
        SYNAPSE_VALIDATION: 'bg-[#FAEEDA] text-[#633806]',
        ADMINISTRATIVE_INFO: 'bg-[#EEEDFE] text-[#3C3489]',
        CONTRACT_GENERATION: 'bg-[#E6F1FB] text-[#0C447C]',
        OFFICE_APPOINTMENT: 'bg-[#F1EFE8] text-[#444441]',
        COMPLETE: 'bg-[#F1EFE8] text-[#444441]',
    };
    const stepBadgeClass = STEP_BADGE_CLASS_BY_STEP[step] || 'bg-medium text-greyStrong';

    return (
        <span className={['px-2  rounded-full font-medium whitespace-nowrap', stepBadgeClass].join(' ')}>
            <Label size="small">{t(`management.onboarding.step.${step}`)}</Label>
        </span>
    );
};

export default OnboardingStepTag;
